import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import DataTable from "react-data-table-component";

// Components


import { InputField } from "../../../Components/formElements/InputField";
import { ComboboxField } from "../../../Components/formElements/ComboboxField";
import { isValidNumber } from "../../../common/Validations";

const HeaderText = React.forwardRef((props, ref) => {
  const [errorMsg, setErrorMsg] = useState("");
 // eslint-disable-next-line
  const [getDocumentIdData, setDocumentIdData] = useState([
    {
      code: "301",
      name: "301 - Freight charge",
      textField: "documentId",
    },
    {
      code: "302",
      name: "302 - Shipment charge",
      textField: "documentId",
    },
    {
      code: "303",
      name: "303 - Other charge",
      textField: "documentId",
    },
  ]);

  const [getDropdownData, setDropdownData] = useState("");

  const [formInputs, setFormInputs] = useState({
    ref: props.index,
    itemIndex: props.index + 1,
    documentId: "",
    documentText: "",
  });

  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);

  const HeaderTextColumns = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId}</span>,
      width: "250px",
    },
    {
      name: "Value",
      cell: (row) => <span>{row.documentText}</span>,
      width: "300px",
    },
    {
      name: "Delete",
      cell: (row, index) => (
        <i
          onClick={() => handleDelete(index)}
          className="bi bi-trash close-btn"
        ></i>
      ),
      width: "10rem",
    },
  ];

  const handleDelete = (indexToDelete) => {
    setHeaderTextSelectedData((prev) =>
      prev.filter((_, index) => index !== indexToDelete)
    );
  };

  const handleHeaderTextSelectedData = () => {
    if (formInputs.documentText && formInputs.documentId) {
      setHeaderTextSelectedData((prev) => [
        ...prev,
        {
          ...formInputs,
          ref: props.index,
          itemIndex: props.index + 1,
        },
      ]);
      setFormInputs({ documentId: "", documentText: "" });
      setErrorMsg("");
    } else {
      setErrorMsg("* Please enter Header text / Document Id");
    }
  };

  const handleSave = () => {
    props.hedertextdata(getHeaderTextSelectedData);
    props.onHide();
  };

  useEffect(() => {
    setHeaderTextSelectedData(props.showcurrentdata || []);
    setFormInputs({ documentId: "", documentText: "" });
  }, [props]);

  const onInputChange = ({ target: { name, value } }) => {
    if (props?.type === "Number") {
      if (isValidNumber(value)) {
        setFormInputs((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setFormInputs((prev) => ({ ...prev, [name]: value }));
    }
  };

  // ✅ Dropdown value mapping
  useEffect(() => {
    if (getDropdownData?.name) {
      setFormInputs((prev) => ({
        ...prev,
        [getDropdownData.textField]: getDropdownData.name,
      }));
    }
  }, [getDropdownData]);

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="xl"
      backdrop="static"
      centered
    >
      <Modal.Header>
        <Modal.Title>
          <i className="bi bi-plus-lg"></i> {props.headername}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
         <div className="space-y-4">
         <Row className="d-flex">
          <Col xs={12} md={5} lg={5} className="commLeftRightPadding">
            <ComboboxField
              label="Code"
              data={getDocumentIdData}
              id="documentId"
              name="documentId"
              setValue={formInputs.documentId}
              getvalue={setDropdownData}
            />
          </Col>

         <Col xs={10} md={5} lg={5} className="commLeftRightPadding">
            <InputField
              label="Value"
              name="documentText"
              value={formInputs.documentText}
              onChange={onInputChange}
            />
          </Col>

           <Col xs={2} md={1} lg={1} className="">
            <button
              className="btnTable mt-4"
              onClick={handleHeaderTextSelectedData}
            >
              <i className="bi bi-plus-lg"></i>
            </button>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <DataTable
              columns={HeaderTextColumns}
              data={getHeaderTextSelectedData}
              selectableRows
            />
          </Col>
        </Row>

        <Row className="justify-end">
           <Col xs={6} md={3} lg={2} className="commLeftRightPadding">
            <button className="btn btn-danger w-100" onClick={props.onHide}>
              Cancel
            </button>
          </Col>
          <Col xs={6} md={3} lg={2} className="commLeftRightPadding">
            <button className="btn btn-primary w-100" onClick={handleSave}>
              Save
            </button>
          </Col>
          <Col md={12}>
            <p className="errorMsg">{errorMsg}</p>
          </Col>
        </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default HeaderText;
